import React from "react";
import "../../assets/css/BotonWhatsapp.css";

const whatsappIcon = "/assets/img/whatsapp.svg";
const BotonWhatsapp = () => {
  const whatsappNumber = "5215620863653";
  const message = encodeURIComponent("Hola, ví su web en Google, me podrían dar más información de sus productos");

  return (
    <a
      className="boton-whatsapp"
      href={`https://wa.me/${whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <img src={whatsappIcon} alt="WhatsApp" />
      <span className="whatsapp-text">WhatsApp</span>
    </a>
  );
};

export default BotonWhatsapp;